import * as React from "react";

import {Link} from "react-router-dom";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
  ConstHeight,
  ConstZIndex,
} from "../../../config/styles_const/styles_const";
import {Client} from "../../../domain/model/client";
import {Role} from "../../../domain/model/user";
import Assets from "../../assets/img/assets";
import BtnCorporateLarge from "../../common/atom/btn/btn_corporate_large";
import BtnLinkBorderSmall from "../../common/atom/btn/btn_link_border_small";
import BtnLinkCorporateSmall from "../../common/atom/btn/btn_link_corporate_small";

interface IProps {
    handleOpenMenu: (event: React.MouseEvent<HTMLElement>) => void;
    userRole: Role;
    isMessageRoom: boolean;
    isTutorial: boolean;
    isCustomerCreate: boolean;
    isDemo: boolean;
    client: Client | null;
}

const LayoutHeaderComponent: React.FC<IProps> = (props) => {
    const {
        handleOpenMenu,
        userRole,
        isMessageRoom,
        isTutorial,
        isCustomerCreate,
        isDemo,
    } = props;

    return (
        <LayoutPosition>
            <LayoutWrapper>
                <TitleLink to={`/login`}>
                    <TitleLogo src={Assets.expert_network_logo}/>
                    {isDemo && (
                        <span
                            style={{
                                display: "inline-block",
                                marginLeft: 10,
                                fontSize: 18,
                                lineHeight: 24,
                                fontWeight: "bold",
                                color: "#FFF",
                            }}
                        >
              パートナーアカウント
            </span>
                    )}
                </TitleLink>
                <LayoutRight>
                    {userRole === Role.Role_Unknown && (
                        <LinkButtonWrapper>
                            {isCustomerCreate ? (
                                <SignUpButton to={`/apply_client/_register`}>
                                    法人の方はこちら
                                </SignUpButton>
                            ) : (
                                <div>
                                    <SignUpButton to={`/customer/_create`}>エキスパート新規登録</SignUpButton>
                                    <SignUpButton to={`/apply_client/_register`}>法人新規登録</SignUpButton>
                                </div>
                            )}
                            <LoginButton to={`/login`}>ログイン</LoginButton>
                        </LinkButtonWrapper>
                    )}

                    {userRole === Role.Role_Client && props.client && (
                        <div style={{display: "flex"}}>
                            <OnlyPCLinks>
                                <a
                                    href="/client/billing/plan"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        textAlign: "center",
                                        marginRight: 20,
                                    }}
                                >
                                    <img
                                        style={{
                                            width: 15,
                                        }}
                                        src={Assets.headerPlan}
                                    />
                                    <span
                                        style={{
                                            color: "white",
                                            fontSize: 12,
                                            display: "inline-block",
                                            marginLeft: 3,
                                        }}
                                    >
                    プランの確認
                  </span>
                                </a>

                                <a
                                    href="/client/clients/_create"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        textAlign: "center",
                                        marginRight: 20,
                                    }}
                                >
                                    <img
                                        style={{
                                            width: 15,
                                        }}
                                        src={Assets.headerUser}
                                    />
                                    <span
                                        style={{
                                            color: "white",
                                            fontSize: 12,
                                            display: "inline-block",
                                            marginLeft: 3,
                                        }}
                                    >
                    メンバーを招待
                  </span>
                                </a>
                            </OnlyPCLinks>

                            <a
                                href="/client/mypage/client"
                                style={{
                                    display: "block",
                                    marginRight: 20,
                                }}
                            >
                                <img
                                    style={{
                                        width: 30,
                                        height: 30,
                                        objectFit: "cover",
                                        borderRadius: 15,
                                    }}
                                    src={props.client.getIconURL()}
                                />
                            </a>
                        </div>
                    )}
                </LayoutRight>
                <div style={{position: "absolute", left: 0}}>
                    {userRole !== Role.Role_Unknown && !isMessageRoom && !isTutorial && (
                        <MenuButton icon={"'\f0c9'"} onClick={handleOpenMenu}/>
                    )}
                </div>
            </LayoutWrapper>
        </LayoutPosition>
    );
};

export default LayoutHeaderComponent;

const OnlyPCLinks = styled.div`
    display: none;
    @media screen and (min-width: 414px) {
        display: flex;
    }
`;

const LayoutPosition = styled.div`
    background-color: ${ConstColor.DeepBlack};
    position: sticky;
    top: 0; /* 固定する位置 */
    left: 0; /* 固定する位置 */
    right: 0; /* 固定する位置 */
    z-index: ${ConstZIndex.layout};
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        position: relative;
    }
`;

const LayoutWrapper = styled.div`
    display: flex;
    height: ${ConstHeight.HeaderHeightSp};
    justify-content: center;
    align-items: center;
    position: relative;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        height: ${ConstHeight.HeaderHeight};
    }
`;

const LayoutRight = styled.div`
    position: absolute;
    right: 0;
`;

const MenuButton = styled(BtnCorporateLarge)`
    height: ${ConstHeight.HeaderHeightSp};
    width: ${ConstHeight.HeaderHeightSp};
    background: ${ConstColor.Base};
    color: ${ConstColor.White};
    border-radius: ${ConstBorderRound.CornerRoundNon} @media screen and(
    min-width: ${ConstBreakPoint.Default}) {
    height: ${ConstHeight.HeaderHeight};
    width: ${ConstHeight.HeaderHeight};
}
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        display: none;
    }
`;

const LinkButtonWrapper = styled.div`
    display: none;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: flex;
    }
`;

const SignUpButton = styled(BtnLinkBorderSmall)`
    background: inherit;
    color: ${ConstColor.White};
    border-color: ${ConstColor.White};
    margin-right: 10px;
`;

const LoginButton = styled(BtnLinkCorporateSmall)`
    margin-right: 20px;
`;

const TitleLogo = styled.img`
    height: 100%;
`;

const TitleLink = styled(Link)``;



// WEBPACK FOOTER //
// ./src/presentation/component/layout/layout_header.tsx